import { WALLET_PROVIDER } from '../../constants/wallet.constants';
import { connectMetaMask, getMetaMaskProvider } from './nonCustodialWallet.service';

const providerRegistry = {
  [WALLET_PROVIDER.METAMASK]: {
    id: WALLET_PROVIDER.METAMASK,
    label: 'MetaMask',
    isAvailable: () => Boolean(getMetaMaskProvider()),
    connect: connectMetaMask,
  },
};

export const getNonCustodialProvider = (providerId) => {
  const key = String(providerId ?? WALLET_PROVIDER.METAMASK).toLowerCase();
  return providerRegistry[key] ?? providerRegistry[WALLET_PROVIDER.METAMASK];
};

export const registerNonCustodialProvider = (providerId, providerDefinition) => {
  if (!providerId || !providerDefinition) return;
  providerRegistry[String(providerId).toLowerCase()] = providerDefinition;
};

export default providerRegistry;
